import { render, staticRenderFns } from "./ModalVisualizarDesenho.vue?vue&type=template&id=3261458d&scoped=true"
import script from "./ModalVisualizarDesenho.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarDesenho.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarDesenho.vue?vue&type=style&index=0&id=3261458d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3261458d",
  null
  
)

export default component.exports